import React, { useContext } from 'react';

import i18nContext from '@components/i18n/i18nContext';
import { findNodeByLanguage } from '@helpers/languages';

const DEFAULT_LANGCODE = 'en';

export function useSocialMediaLinks() {
  const { lng } = useContext(i18nContext);
  const langcode = lng || DEFAULT_LANGCODE;

  const result = {
    allBlockContentSocialLinksBlock: {
      nodes: [
        {
          langcode: 'en',
          relationships: {
            field_social_link: [
              {
                drupal_id: 'e49d23b1-4cd5-4e6d-8c23-69bb98b0c53f',
                field_social_media_type: 'facebook',
                field_social_media_link: {
                  uri: 'https://www.facebook.com/LucidMotors/',
                },
              },
              {
                drupal_id: '0c39878f-1106-465b-8537-231e13f6d05a',
                field_social_media_type: 'instagram',
                field_social_media_link: {
                  uri: 'https://www.instagram.com/lucidmotors/',
                },
              },
              {
                drupal_id: 'de98a8f0-10ec-45a1-b353-8e5a6f7c78f1',
                field_social_media_type: 'twitter',
                field_social_media_link: {
                  uri: 'https://twitter.com/LucidMotors',
                },
              },
              {
                drupal_id: 'fdf45852-f22c-489b-8e5d-3959a12a6f4c',
                field_social_media_type: 'youtube',
                field_social_media_link: {
                  uri: 'https://www.youtube.com/lucidmotors',
                },
              },
            ],
          },
        },
      ],
    },
  };
  const { nodes } = result.allBlockContentSocialLinksBlock;

  return findNodeByLanguage(nodes, langcode);
}

/**
 *
 * For classes
 *
 */
export const withSocialMediaLinks = Component =>
  Object.assign(
    props => {
      const social = useSocialMediaLinks();
      return <Component social={social} {...props} />;
    },
    { displayName: 'withSocialMediaLinks' }
  );
